
import Vue from "vue";
import { Component, Prop, Ref } from "vue-property-decorator";
import PanelHeader from "@/components/Reusable/Util/PanelHeader.vue";
import History from "@/components/HistoryAndRevisions/History/History.vue";
import Revisions from "@/components/HistoryAndRevisions/Revisions/Revisions.vue";
import {
  closeUiPanel,
  scrollToHtmlElementInsidePanel
} from "@/lib/panels/panels";
import TabsRow from "@/components/Reusable/Tabs/TabsRow.vue";
import Tab from "@/components/Reusable/Tabs/Tab.vue";

type HistoryOrRevisionTab = "history" | "revisions";

@Component({
  components: {
    Revisions,
    History,
    PanelHeader,
    TabsRow,
    Tab
  }
})
export default class HistoryAndRevisionsPanel extends Vue {
  tab: HistoryOrRevisionTab = "history";

  @Prop({ default: false })
  disableRevisions!: boolean;

  @Ref() readonly panelHeader!: PanelHeader;

  close() {
    closeUiPanel("history");
  }

  scrollToActiveElement(activeEl: Element) {
    scrollToHtmlElementInsidePanel(this.$el, this.panelHeader.$el, activeEl);
  }
}
